/* eslint-disable import/prefer-default-export */
import styled from 'react-emotion';

export const FilterContainer = styled.div`
  border-radius: 4px;
  width: 200px;
  display: flex;
  align-items: center;
`;
